import { Component, OnInit } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { ReportesCobranzaService } from '../../../services/reportes/reportes-cobranzas.service';
import { ReportsHelperService } from '../../../services/tools/reports-helpers.service';
import { ConveniosService } from "../../../services/convenios.service";
import { SucursalesService } from '../../../services/sucursales.service';

@Component({
    selector: 'reporte-cobranza-nomina',
    templateUrl: './reporte-cobranza-nomina.component.html'
  })

export class ReporteCobranzaNominaComponent implements OnInit {

    public reportData: any [] = [];
    public totales: any = {};
    public convenios: any[] = [];
    //Filtros
    public fechaFin: string = null;
    public convenio: any = '';
    //Helpers
    public isLoading: boolean = true;
    public isItemsArrayEmpty: boolean = null;
    
    public sucursales: any[] = [];
    public sucursal: any = {id:null};
    public sucursalPorDefecto: string = "";

    constructor(
        private helperService: HelpersService,
        private reportesService: ReportesCobranzaService,
        public helper: ReportsHelperService,
        private conveniosService: ConveniosService,
        private sucursalesService : SucursalesService
    ){

    }

    public ngOnInit() {
        this.setupDefaultState();
    }

    private setupDefaultState() {
        this.fechaFin = this.helper.getDefaultCobranzaDate();

        this.getConvenios();
        this.getSucursales();
    }
    private getSucursales(){
        this.isLoading = true;
        this.sucursalesService.get().subscribe(
          (response)=>
          {
            const jsonResult = response.json();
            if(jsonResult.content){
              this.sucursales = jsonResult.content.data;
              if (this.sucursales.length>1){
                this.sucursalPorDefecto = "Seleccione";
              } else if(this.sucursales.length>0){
                this.sucursal =  this.sucursales[0];
              }
              this.updateReporte();
              this.isLoading = false; 
            }
            
          }, error =>
          {
            // se resuelve error 403 y 500
            this.isLoading = false;
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }
    
    sucursalChanged(sucursal){
        if(sucursal){
        this.sucursal = sucursal;
        this.updateReporte();
        }
    }

    public updateReporte(){

        let filters = {
            fechaFin: this.fechaFin,
            convenio: this.convenio,
            sucursal : this.sucursal.id
        }

        //Mostrar el ajax loading
        this.isLoading = true;

        this.reportesService.nomina(filters).subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                let items = [];
                let totales = {};
                if(jsonResult.content ){
                    if(jsonResult.content.items){
                        items = jsonResult.content.items;
                    }
                    if(jsonResult.content.totales){
                        totales = jsonResult.content.totales;
                    }
                }

                this.reportData = items;
                this.totales = totales;
                this.isLoading = false;
                this.isItemsArrayEmpty = this.reportData.length == 0;
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    public print(){
        //Imprimir pantalla
        window.print();
    }

    //Reporte de nomina
    public getConvenios(){    
        this.conveniosService.getAll({ paginate : false, order : 'razon_social' }).subscribe(
            (response)=>
            {
            const jsonResult = response.json();
            if(jsonResult.content){
                this.convenios = response.json().content;
            }
            
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    public descargar() {

        let filters = {
            fechaFin: this.fechaFin,
            convenio: this.convenio
        }

        this.reportesService.exportNominaToExcel(filters).subscribe(
            (response)=>
            {
            const fileUrl = window.URL.createObjectURL(response.blob());
            //Muestra el archivo en una nueva ventana
            window.open(fileUrl);
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/reportes/cobranza/nomina/reporte-cobranza-nomina.component.ts